export const ACTUALIZAR_LIST_SUBSISTEMA = "ACTUALIZAR_LIST_SUBSISTEMA";

